import { Box, Container } from "@mui/material";
import { useAppTranslation } from "../../../../hooks/useAppTranslation";
import Title from "../../../../common/title/title.components";
import Description from "../../../../common/description/description.components";
import StyledWrapper from "./speakers-overlay-section.styles";

const SpeakersOverlaySection = () => {
  const { t } = useAppTranslation();
  return (
    <StyledWrapper id="speakers">
      <Container className="speakers-content-container">
        <Box className="speakers-text">
          <Title className="speakers-title" text={t("speakers.label")} />
          <Description className="speakers-description" text={t("speakers.description")} />
        </Box>
      </Container>
    </StyledWrapper>
  );
};

export default SpeakersOverlaySection;
